
import { useParams, useNavigate } from "react-router-dom";
import { Shell } from "@/components/layout/Shell";
import { CurrencyForm } from "@/components/currencies/CurrencyForm";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useCurrencies } from "@/hooks/useCurrencies";
import { Currency } from "@/lib/types";
import { useTranslation } from "react-i18next";

export default function CurrencyEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const { useCurrencyQuery } = useCurrencies();
  const { data: currency, isLoading, error } = useCurrencyQuery(id || '');

  const handleSuccess = (updatedCurrency: Currency) => {
    navigate("/currencies");
  };

  if (isLoading) {
    return (
      <Shell>
        <div>{t('loadingData', { resource: t('Currency') })}</div>
      </Shell>
    );
  }

  if (error || !currency) {
    return (
      <Shell>
        <div>{t('errorLoading', { resource: t('Currency') })}</div>
      </Shell>
    );
  }

  return (
    <Shell>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">{t('edit')} {t('Currency')}</h1>
          <p className="text-muted-foreground">
            {t('update')} {t('Currency').toLowerCase()} {t('details')}
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>{t('currencyDetails')}</CardTitle>
            <CardDescription>
              {t('updateCurrencyDetails', { name: currency.name })}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <CurrencyForm
              currency={currency}
              onSuccess={handleSuccess}
            />
          </CardContent>
        </Card>
      </div>
    </Shell>
  );
}
